module.exports = __webpack_public_path__ + "img/logo.e935f3fe.png";